export const parseCompanyId = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
};

export const resolveCompanyDisplayName = (company) => {
  if (!company) return null;
  const id = parseCompanyId(company.id);
  return company.company_name || company.companyName || company.name || company.label || (id ? `Companie ${id}` : null);
};

export const parseEmployeeId = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  const numeric = Number(value);
  return Number.isNaN(numeric) ? null : numeric;
};

export const deriveEmployeeId = ({ propId, routeParamId, routeQueryId, storageId }) => {
  const sources = [propId, routeParamId, routeQueryId, storageId];
  for (const source of sources) {
    const parsed = parseEmployeeId(source);
    if (parsed !== null) {
      return parsed;
    }
  }
  return null;
};
